"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    mutation postUserSignupForm($content: UserSignupForm!) {
        postUserSignupForm(content: $content)
    }
`;exports.postUserSignupForm=e;
//# sourceMappingURL=queries.js.map
